<template>
  <BCard>
    <h4 class="font-medium text-black text-2xl mb-2">
      Monitoring Saldo Minus
    </h4>
    <div class="p-1 border border-2 rounded-xl bg-[#FFF5F1] my-2 d-flex justify-between custom-bg">
      <div>
        <div class="d-flex gap-10">
          <div class="py-[9px] px-[6px] bg-[#FFCFCF] rounded-xl">
            <span
              class="rounded-pill text-[#E31A1A] py-[3px] px-[2px] font-bold"
              style="border: solid 2px #E31A1A;"
            >
              ($)
            </span>
          </div>
          <span class="align-self-center text-[16px]">Saldo Minus Bulan ini</span>
          <span
            id="tooltip-saldo-minus"
            class="k-info-circle align-self-center text-info"
          />
          <b-tooltip
            target="tooltip-saldo-minus"
            triggers="hover"
            variant="light"
          >
            <div class="text-start">
              <div class="mb-1">
                <b>Monitor Saldo Minus</b>
              </div>
              <div>Saldo partner yang bernilai minus untuk transaksi</div>
            </div>
          </b-tooltip>
        </div>
        <div class="d-flex gap-4 my-2">
          <div class="font-bold text-5xl text-black">
            <BSpinner
              v-if="isLoading"
              small
              class="ml-1"
              variant="primary"
            />
            <span v-else>
              {{ IDR(countSaldo) }}
            </span>
          </div>
          <span class="text-white bg-[#E31A1A] px-[8px] py-[4px] align-self-center rounded-pill text-xs">
            <BSpinner
              v-if="isLoading"
              small
              class="ml-1"
              variant="light"
            />
            <span v-else>{{ percent }}%</span>
          </span>
        </div>
        <div class="d-flex gap-10 my-2">
          <div>
            Jumlah User :
            <BSpinner
              v-if="isLoading"
              small
              class="ml-1"
              variant="primary"
            />
            <span v-else>{{ countUser }}</span> User
          </div>
          <span> | </span>
          <div>
            Saldo Minus Tahun Ini :
            <BSpinner
              v-if="isLoading"
              small
              class="ml-1"
              variant="primary"
            />
            <span
              v-else
              class="font-medium"
            >{{ IDR(countSaldoYearly) }}</span>
          </div>
        </div>
      </div>
      <div class="">
        <flat-pickr
          v-model="filterMonth"
          class="custom-select"
          :config="flatpickrMonthly"
        />
      </div>
    </div>
    <div class="d-flex justify-content-between flex-wrap gap-[10px]">
      <div class="font-medium text-black text-xl align-self-center">
        Data Partner
      </div>
      <div class="d-flex gap-[10px] justify-content-end col-12 col-lg-10">
        <!-- search -->
        <b-input-group
          class="input-group-merge col-8 col-lg-4 p-0"
          size="md"
        >
          <b-input-group-prepend is-text>
            <feather-icon icon="SearchIcon" />
          </b-input-group-prepend>
          <b-form-input
            v-model="search"
            :minlength="2"
            type="search"
            placeholder="Cari nama partner atau email disini"
            debounce="500"
            @input="onChangeSearch"
          />
        </b-input-group>
        <!-- download -->
        <b-button
          variant="primary"
          size="sm"
          class="w-[130px] shrink-0 filter-button"
          :disabled="progressDownload"
          @click="downloadListSaldoMinus()"
        >
          <b-spinner
            v-if="progressDownload"
            small
            variant="light"
          />
          <div
            v-else
            class="flex items-center justify-between h-full w-full"
          >
            <span class="leading-[1.2]">Download</span>
            <span class="k-document-download text-2xl" />
          </div>
        </b-button>
      </div>
    </div>
    <BOverlay
      :show="isLoading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <BTable
        ref="table-scroll"
        :items="listData"
        :fields="fieldListData"
        show-empty
        empty-text="Tidak ada data yang ditampilkan."
        class="mt-1"
        hover
        sticky-header="500px"
        :fixed="windowWidth > 1000"
        :relative="windowWidth <= 1000"
        @scroll.native="handleScroll"
      >
        <template #cell(name)="data">
          <div class="text-black mb-1">
            {{ data.value }}
          </div>
          <div class="text-xs">
            {{ data.item.email }}
          </div>
        </template>
        <template #cell(phone)="data">
          <div
            class="cursor-pointer d-flex gap-4"
            @click="redirectToWa(data.value)"
          >
            <img
              src="https://storage.googleapis.com/komerce//whatsapp-ori.svg"
              alt="whatsapp"
            >
            <span class="align-self-center">0{{ data.value }}</span>
          </div>
        </template>
        <template #cell(products)="data">
          <div class="d-flex justify-content-center grid-5">
            <div
              v-for="(logo, index) in getProduct(data.item)"
              :key="index"
              :class="index !== 0 ? '-ml-3' : ''"
              class="p-[5px] rounded-pill bg-[#F8F8F8]"
            >
              <img
                :src="logo"
                style="max-width: 20px"
              >
            </div>
            <span
              v-if="data.item.products === null"
              class="flex justify-content-center"
            >-</span>
          </div>
        </template>
        <template #cell(register_date)="data">
          {{ DAY_MONTH_YEAR(data.value) }}
        </template>
        <template #cell(amount)="data">
          {{ IDR(data.value) }}
        </template>
        <template #cell(id)="data">
          <span
            class="cursor-pointer"
            @click="redirectDetail(data.value)"
          >
            Details
          </span>
        </template>
      </BTable>
    </BOverlay>
  </BCard>
</template>

<script>
import {
  START_DATE_OF_MONTH, END_DATE_OF_MONTH, DAY_MONTH_YEAR, LABEL_MONTH_YEAR,
} from '@/libs/filterDate'
import { today, formatYmd } from '@/store/helpers'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/plugins/monthSelect/style.css'
import { IDR } from '@/libs/currency'
import { newAxiosIns } from '@/libs/axios'
import { configFlatPickr, fieldListData } from './config'

export default {
  components: { flatPickr },
  data() {
    return {
      IDR,
      DAY_MONTH_YEAR,

      fieldListData,
      listData: [],

      search: '',
      filterMonth: formatYmd(today),
      flatpickrMonthly: configFlatPickr,

      countSaldo: null,
      percent: null,
      countUser: null,
      countSaldoLastMonth: null,
      countSaldoYearly: null,

      isLoading: false,
      windowWidth: window.innerWidth,
      limit: 20,
      offset: 0,
      lastData: false,
      progressDownload: false,
    }
  },
  watch: {
    filterMonth(newVal) {
      if (newVal !== null) {
        this.getListData()
        this.getCountSaldo()
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.updateWindowWidth)
    this.getCountSaldo()
    this.getListData()
  },
  methods: {
    async getCountSaldo() {
      this.isLoading = true
      const params = {
        start_date: START_DATE_OF_MONTH(this.filterMonth),
        end_date: END_DATE_OF_MONTH(this.filterMonth),
      }
      const url = '/auth/api/v1/admin/user-balance-history/total-amount'
      await newAxiosIns.get(url, { params })
        .then(response => {
          const { data } = response.data
          this.countSaldo = data.current_total_amount
          this.percent = data.percentage_change
          this.countUser = data.total_user
          this.countSaldoLastMonth = data.previous_total_amount
          this.countSaldoYearly = data.yearly_total_amount
          this.isLoading = false
        })
        .catch(err => {
          this.isLoading = false
          this.$toast_error({ message: 'Gagal Mendapatkan Jumlah Saldo Minus' })
        })
    },
    async getListData() {
      this.isLoading = true
      const params = {
        start_date: START_DATE_OF_MONTH(this.filterMonth),
        end_date: END_DATE_OF_MONTH(this.filterMonth),
        search: this.search,
        limit: this.limit,
        offset: 0,
      }

      const scrollContainer = this.$refs['table-scroll'].$el

      const url = '/auth/api/v1/admin/user-balance-history'
      await newAxiosIns.get(url, { params })
        .then(response => {
          const data = Array.isArray(response.data.data) ? response.data.data : []

          this.listData = data.sort((a, b) => a.amount - b.amount)
          this.offset = data.length
          this.isLoading = false
          if (scrollContainer) {
            scrollContainer.scrollTop = 0
          }

          if (data.length < this.limit) {
            this.lastData = true
          } else {
            this.lastData = false
          }
          this.isLoading = false
        })
        .catch(err => {
          this.$toast_error({ message: 'Gagal Mendapatkan List Data' })
          this.listData = []
          this.isLoading = false
        })
    },
    async getListNextData() {
      this.isLoading = true
      if (!this.lastData) {
        const params = {
          start_date: START_DATE_OF_MONTH(this.filterMonth),
          end_date: END_DATE_OF_MONTH(this.filterMonth),
          search: this.search,
          limit: this.limit,
          offset: this.offset,
        }

        const scrollContainer = this.$refs['table-scroll'].$el

        const url = '/auth/api/v1/admin/user-balance-history'
        await newAxiosIns.get(url, { params })
          .then(response => {
            const data = Array.isArray(response.data.data) ? response.data.data : []

            this.listData.push(...data)
            this.listData.sort((a, b) => a.amount - b.amount)
            this.offset += data.length
            this.isLoading = false
            if (scrollContainer) {
              scrollContainer.scrollTop = 0
            }

            if (data.length < this.limit) {
              this.lastData = true
            }
            this.isLoading = false
          })
          .catch(err => {
            this.$toast_error({ message: 'Gagal Mendapatkan List Data' })
            this.listData = []
            this.isLoading = false
          })
      }
    },
    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target
      if (scrollTop + clientHeight >= scrollHeight - 1 && !this.loading
      && !this.lastData) {
        this.page += 1
        this.getListNextData()
      }
    },
    getProduct(item) {
      const productOf = [
        item.is_komship === 1 ? 'https://storage.googleapis.com/komerce/icon/komship-with-fill.svg' : '',
        item.is_komtim === 1 ? 'https://storage.googleapis.com/komerce/icon/komtim-with-fill.svg' : '',
        item.is_kompack === 1 ? 'https://storage.googleapis.com/komerce/icon/kompack-with-fill.svg' : '',
        item.is_komcard === 1 ? 'https://storage.googleapis.com/komerce/icon/komcards-with-fill.svg' : '',
        item.is_komplace === 1 ? 'https://storage.googleapis.com/komerce/icon/komplace-with-fill.svg' : '',
        item.is_pendamping_umkm === 1 ? 'https://storage.googleapis.com/komerce/icon/pumkm-with-fill.svg' : '',
        item.is_affiliate === 1 ? 'https://storage.googleapis.com/komerce/icon/affiliate-with-fill.svg' : '',
        item.is_komform === 1 ? 'https://storage.googleapis.com/komerce/icon/komform-with-fill.svg' : '',
      ].filter(Boolean)

      return productOf
    },
    onChangeSearch: _.debounce(function search() {
      const trimmedSearch = this.search.trim()
      this.search = trimmedSearch

      if (trimmedSearch.length > 2) {
        this.getListData()
      } else if (this.search === '') {
        this.getListData()
      }
    }, 1000),
    updateWindowWidth() {
      this.windowWidth = window.innerWidth
    },
    redirectToWa(value) {
      window.open(`https://wa.me/62${value.substring(1)}`, '_blank')
    },
    redirectDetail(id) {
      const routeData = this.$router.resolve(`/information/details/${id}`)
      window.open(routeData.href, '_blank')
    },
    downloadListSaldoMinus() {
      this.progressDownload = true
      const url = '/auth/api/v1/admin/user-balance-history/export'
      newAxiosIns.get(`${url}?start_date=${START_DATE_OF_MONTH(this.filterMonth)}&end_date=${END_DATE_OF_MONTH(this.filterMonth)}`, { responseType: 'blob' })
        .then(resp => {
          const blob = new Blob([resp.data], { type: resp.headers })
          const urlObj = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = urlObj
          a.download = `monitoring_saldo_minus_${LABEL_MONTH_YEAR(this.filterMonth)}.xlsx`
          a.click()
          a.remove()
          URL.revokeObjectURL(urlObj)
          this.progressDownload = false
        })
        .catch(response => {
          this.$toast_error({ message: 'Gagal Mengunduh List Data' })
          this.progressDownload = false
        })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '~@core/scss/vue/libs/vue-flatpicker.scss';
.custom-bg {
  background-image: url('https://storage.googleapis.com/komerce/assets/illustration/bg-monitoring-saldo-minus.png');
  background-repeat: no-repeat;
  background-size: auto;
  background-position: bottom right 100px;
}
</style>
